import { render, staticRenderFns } from "./RequestBlock.vue?vue&type=template&id=0f3b1c45&scoped=true&"
import script from "./RequestBlock.vue?vue&type=script&lang=js&"
export * from "./RequestBlock.vue?vue&type=script&lang=js&"
import style0 from "./RequestBlock.vue?vue&type=style&index=0&id=0f3b1c45&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f3b1c45",
  null
  
)

component.options.__file = "RequestBlock.vue"
export default component.exports